import one from '../images/cover.jpg'

function Section3() {
    return (
        <div className="main3">
            <img src={one} alt="img"/>

                <div className="main3_1">
                    <h2>Udemy Flash Sale!! 24 hours to save</h2>
                    <p>Get the top Courses for just 499.Just one dat to save but a lifetime to learn</p>
                </div>
        </div>
    )
}

export default Section3